export default {
  title: "Welkom bij Stickyweb!",
  text: "Stel hieronder uw wachtwoord in",

  input: {
    password: "Wachtwoord",
    passwordRepeat: "Herhaal wachtwoord",
  },

  button: {
    save: "Registratie afronden"
  },

  tokenError: {
    title: "Error",
    intro: "Er iets fout gegaan met de registratie link, u kunt het volgende proberen:",
    text: {
      copied: "Wanneer u de link gekopieerd heeft, controleer dat dit volledig en correct is gedaan.",
      registered: "Misschien heb je de e-mail al gebruikt, probeer in te loggen of een nieuw wachtwoord aan te vragen.",
      contact: "Neem anders even contact met ons op, dan helpen wij je graag verder.",
    },
  },

  api: {
    success: {
      accountCreated: "Je wachtwoord is ingesteld. Veel plezier met Stickyweb!",
    },
    error: {
      token: {
        invalid: "Onze excuses, maar de identificatie token klopt niet",
      },
      passwords: {
        equal: "De wachtwoorden komen niet overeen",
      }
    },
  },

  validate: {
    require: "Voer een wachtwoord in",
  }
}
